import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"; // ensure you're using 'Routes' from react-router-dom v6
import { About } from "./pages/About";
import { Home } from "./pages/Home";
import { Music } from "./pages/Music";
import { Gigs } from "./pages/Gigs";
import Navbar from "./components/navbar";
import Footer from "./components/footer";

function App() {
  return (
    <div>
      <Router>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/Music" element={<Music />} />
          <Route path="/Gigs" element={<Gigs />} /> 

        </Routes>
          <Footer />
      </Router>
    </div>
  );
}

export default App;
